import React from 'react';

export function SplitCol({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  return <div className="odin-grid odin-grid-cols-2">{children}</div>;
}
